const initialValues = () => ({
    NewPassword: '',
    ConfirmPassword: '',
    Password: '',
});
export default initialValues;
